import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'

// Lessons. /club/lessons. Each references a member. Notes + payments are
// append-only sub-collections; payments are RECORD-ONLY (never charge).
//   {id}: { memberId, packageName, instructor, scheduledDate, status,
//           notesHistory:{}, payments:{}, createdAt }
const BASE = 'club/lessons'
export const LESSON_STATUSES = ['Scheduled', 'Completed', 'Cancelled']
const num = (v) => (v === '' || v == null ? 0 : Number(v) || 0)

export function watchLessons(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }
export async function createLesson(d) {
  const node = push(tref(BASE))
  await set(node, { id: node.key, memberId: d.memberId || null, packageName: String(d.packageName || '').trim(), instructor: String(d.instructor || '').trim(), scheduledDate: d.scheduledDate || '', status: 'Scheduled', notesHistory: {}, payments: {}, createdAt: Date.now() })
  logActivity({ type: 'lesson', memberId: d.memberId || null, icon: '⛳', text: `Lesson booked: ${d.packageName || 'lesson'}` })
  return node.key
}
export async function setLessonStatus(id, status) { await update(tref(`${BASE}/${id}`), { status }) }
export async function addLessonNote(id, text) {
  const k = push(tref(`${BASE}/${id}/notesHistory`)).key
  await update(tref(`${BASE}/${id}`), { [`notesHistory/${k}`]: { text: String(text || '').trim(), ts: Date.now() } })
}
// Record-only payment log — no processor.
export async function addLessonPayment(id, { amount, note }) {
  const k = push(tref(`${BASE}/${id}/payments`)).key
  await update(tref(`${BASE}/${id}`), { [`payments/${k}`]: { amount: num(amount), note: String(note || '').trim(), ts: Date.now() } })
}
export async function deleteLesson(id) { await remove(tref(`${BASE}/${id}`)) }
